import { MasterDataContainer } from '../../dataAccess/masterDataContainer';
import { SwkFxHeadCacheViewModel } from './swkFxHeadCacheViewModel';

export class SwkFxHeadCacheContainer extends MasterDataContainer<SwkFxHeadCacheViewModel> {
    constructor(models: Array<SwkFxHeadCacheViewModel>, dataYear: number, version: Date) {
        super(models, dataYear, version);
    }
}
